import { observer } from 'mobx-react-lite';
import { ReactElement, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useSDK } from '../../../../../app';
import { truncFilename } from '../../../../../utils/truncFilename';
import { FileIcon } from '../../../../chat/chatMessagesList/attachmentPreview/filePreview/fileIcon';
import { ImagePreview } from '../../../../chat/chatMessagesList/attachmentPreview/imagePreview';
import { messages } from './msgs';

const Component = ({ id }: { id?: number }): ReactElement | null => {
	const { attachmentsStore, showcaseId } = useSDK();
	const intl = useIntl();
	const attachmentInfo = id && attachmentsStore.getAttachmentInfo(id);
	const filename = useMemo(
		() =>
			attachmentInfo
				? truncFilename(attachmentInfo.filename, 15)
				: intl.formatMessage(messages.attachmentNotFound),
		[attachmentInfo, intl]
	);

	if (!attachmentInfo) return null;
	return (
		<>
			<div title={attachmentInfo.filename}>{filename}</div>
			{attachmentInfo?.mimeType.includes('image/') ? (
				<ImagePreview disabledClick attachmentMeta={attachmentInfo} showcaseId={showcaseId} />
			) : (
				<FileIcon />
			)}
		</>
	);
};

export const ReplyAttachmentPreview = observer(Component);
